import { axios } from "..";

export interface IReferralEstimatedFee {
    id?: string;
    legacyId?: string;
    rangeId: number;
    description: string;
    isActive: number;
    displayOrder: number;
}

export const getReferralEstimatedFees = async (excludeNotReported: boolean = false): Promise<IReferralEstimatedFee[]> => {
    const flag = excludeNotReported ? "?excludeNotReported=true" : "";
    const response = await axios.Get(`/referral-estimated-fees${flag}`);
    return response.data ?? [];
};
